import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { isAuthenticated, logout } from '../utils/auth'; // Assuming these are in '../auth'
import Logo from '../components/images/logo.png'

function Home() {
  const navigate = useNavigate();

  const handleLogout = () => {
    logout(() => {
      navigate('/'); // Redirect to home after logout
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Navigation Bar */}
      <nav style={{ backgroundColor: '#f8f9fa', padding: '15px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee' }}>
        {/* Logo (replace with your actual logo) */}
        <div style={{ fontSize: '1.5em', fontWeight: 'bold', color: '#007bff' }}>
          <Link to="/"><img src={Logo} alt="Learning Aids" height={ 35 } /></Link>
        </div>
        {/* Navigation Links */}
        <div className='header-link-block'>
          <div className='navlist'>
            <ul>
              <li><Link to="/courses">Courses</Link></li>
            </ul>
          </div>
          {isAuthenticated() ? (
            <>
              <button
                style={{ backgroundColor: '#dc3545', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', textDecoration: 'none' }}
                onClick={handleLogout}
              >
                Logout
              </button>
              <button
                style={{ backgroundColor: '#007bff', color: 'white', border: 'none', padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', textDecoration: 'none' }}
                onClick={() => navigate('/dashboard')}
              >
                Dashboard
              </button>
            </>
          ) : (
            <>
              <Link to="/login" style={{ color: '#007bff', textDecoration: 'none', marginRight: '15px' }}>Login</Link>
              <Link to="/register" style={{ color: '#007bff', textDecoration: 'none' }}>Register</Link>
            </>
          )}
        </div>
      </nav>

      {/* Banner Section */}
      <div style={{ backgroundColor: '#e9ecef', padding: '80px 20px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '2.5em', color: '#343a40', marginBottom: '20px' }}>Unlock Your Learning Potential</h2>
        <p style={{ fontSize: '1.2em', color: '#6c757d', marginBottom: '30px' }}>
          Explore a wide range of courses and resources designed to help you succeed.
        </p>
        {!isAuthenticated() && (
          <div>
            <Link to="/register" style={{ backgroundColor: '#28a745', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '5px', cursor: 'pointer', fontSize: '1.1em', textDecoration: 'none', marginRight: '15px' }}>
              Get Started
            </Link>
            <Link to="/courses" style={{ backgroundColor: '#007bff', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '5px', cursor: 'pointer', fontSize: '1.1em', textDecoration: 'none' }}>
              Browse Courses
            </Link>
          </div>
        )}
        {isAuthenticated() && (
          <Link to="/courses" style={{ backgroundColor: '#007bff', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '5px', cursor: 'pointer', fontSize: '1.1em', textDecoration: 'none' }}>
            Explore Courses
          </Link>
        )}
      </div>

      {/* Optional: Add more sections below the banner */}
      {/* <div style={{ padding: '40px 20px', textAlign: 'center' }}>
        <h3>Featured Courses</h3>
        </div> */}
    </div>
  );
}

export default Home;